import { encrypted, decrypted } from 'config/crypto';
import { updateModifyOrderIdAction } from 'redux/actions';
import { clearSentryUser } from 'config/sentry';

export const setLocalStorageValue = (key, value) => localStorage.setItem(key, encrypted(value));;

export const getLocalStorageValue = (key) => localStorage.getItem(key) && decrypted(localStorage.getItem(key));

export function generateTimeSlots(start, end, interval) {
  const times = [];
  let [startHour, startMin, startPeriod] = start.match(/(\d+):(\d+) (\w+)/).slice(1);
  let [endHour, endMin, endPeriod] = end.match(/(\d+):(\d+) (\w+)/).slice(1);

  startHour = parseInt(startHour) % 12 + (startPeriod === "PM" ? 12 : 0);
  endHour = parseInt(endHour) % 12 + (endPeriod === "PM" ? 12 : 0);
  startMin = parseInt(startMin);
  endMin = parseInt(endMin);

  let current = new Date(2000, 0, 1, startHour, startMin);
  const endTime = new Date(2000, 0, 1, endHour, endMin);

  while (current <= endTime) {
    let hours = current.getHours();
    let minutes = current.getMinutes();
    let period = hours >= 12 ? "PM" : "AM";
    let displayHour = hours % 12 === 0 ? 12 : hours % 12;
    let displayMin = minutes.toString().padStart(2, "0");

    times.push(`${displayHour}:${displayMin} ${period}`);

    current.setMinutes(current.getMinutes() + interval);
  }

  return times;
}

export function formatDateToYYYYMMDD(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function isKeyurSite() {
  return window.location.host === "keyur-test.web.app"
}

export function setModifyOrderId(orderId) {
  setLocalStorageValue("modify_order_id", orderId);
}

export function clearModifyOrderId(dispatch) {
  setLocalStorageValue("modify_order_id", "");
  dispatch(updateModifyOrderIdAction(""));
}

export function updateModifyOrderId(res, dispatch) {
  const modifyOrderId = res?.data?.modify_order_id;
  if (modifyOrderId == null) {
    return;
  }
  if (modifyOrderId !== "0") {
    setModifyOrderId(modifyOrderId);
    dispatch(updateModifyOrderIdAction(modifyOrderId));
  } else {
    clearModifyOrderId(dispatch)
  }
}

export const handleSignOut = () => {
  clearSentryUser();
  const store = getLocalStorageValue("selected-store-id");
  localStorage.clear();
  setLocalStorageValue('selected-store-id', store);
  window.location.reload();
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

export function addDefaultGtag(gtmId) {
  const gtmScriptUrl = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  
  const existingGtagScript = Array.from(document.querySelectorAll("script")).find(
    (script) => script.src === gtmScriptUrl
  );
  
  if (existingGtagScript) {
    return;
  }

  if (window.dataLayer && window.gtag) {
    return;
  }

  const defaultGtag = document.createElement("script");
  defaultGtag.async = true;
  defaultGtag.src = gtmScriptUrl;
  document.head.appendChild(defaultGtag);

  const defaultGtagInline = document.createElement("script");
  defaultGtagInline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "${gtmId}");
  `;
  document.head.appendChild(defaultGtagInline);
}

export function injectGoogleTagManagerContainer(containerId) {
  if (!containerId || !containerId.startsWith("GTM-")) {
    return;
  }
  const gtmScriptUrl = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  const existing = Array.from(document.querySelectorAll("script")).find(
    (script) => script.src === gtmScriptUrl
  );
  if (existing) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const firstScript = document.getElementsByTagName("script")[0];
  const j = document.createElement("script");
  j.async = true;
  j.src = gtmScriptUrl;
  firstScript.parentNode.insertBefore(j, firstScript);
}

export function isCostBoss() {
  return [
    'cost-boss-beta.web.app',
    'cost-boss.web.app',
    'www.costboss.com',
    'www.shopcostboss.com',
  ].includes(window?.location?.hostname?.toLowerCase());
}